import { RouterLink } from '@/components'
import { OCTA_DESK_PHONE } from '@/constants/phones'
import { useCompany } from '@/context/companies'
import { formatCNPJ } from '@/helpers/format'
import { routes } from '@/router'
import { PersonOutline, QuestionMark } from '@mui/icons-material'
import {
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { generatePath, useNavigate } from 'react-router-dom'
import { useListDeals } from '@/api/accounting-dealer'

export function DashboardHeader() {
  const { data: deals } = useListDeals()
  const { setCompany } = useCompany()
  const navigate = useNavigate()

  const selectedCompanyKey = localStorage.getItem('selected_company')

  const handleCompanyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const companyKey = event.target.value
    setCompany(companyKey)
  }

  const handleMenuItemClick = (isIncomplete: boolean, dealKey: string) => {
    if (isIncomplete) {
      navigate(generatePath(routes.hiring.index, { deal_key: dealKey }), {
        state: { dealKey },
      })
    }
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={3}
    >
      <TextField
        select
        value={selectedCompanyKey || ''}
        onChange={handleCompanyChange}
        size="small"
        sx={{
          maxWidth: 500,
          '& .MuiSelect-select > p:last-child': { display: 'none' },
        }}
      >
        {deals?.map(
          ({ company, status, step, key: dealKey, user_display_name }) => {
            const isOngoing = status === 'ongoing'
            const isOpening = status === 'incomplete' && step === 'signed'
            const isIncomplete = status === 'incomplete' && step !== 'signed'
            const isClosed = status === 'closed'

            return (
              <MenuItem
                key={company.key}
                value={company.key}
                onClick={() => handleMenuItemClick(isIncomplete, dealKey)}
                sx={{ display: 'block' }}
              >
                <Typography noWrap>
                  {company.corporate_name || user_display_name}
                </Typography>
                {isOngoing && (
                  <Typography variant="body2" color="textDisabled">
                    {formatCNPJ(company.tax_id || '')}
                  </Typography>
                )}
                {isOpening && (
                  <Typography color="warning" variant="body2">
                    Processo de abertura em andamento
                  </Typography>
                )}
                {isIncomplete && (
                  <Typography color="warning" variant="body2">
                    Processo de contratação em andamento
                  </Typography>
                )}
                {isClosed && (
                  <Typography color="textDisabled" variant="body2">
                    Encerrada
                  </Typography>
                )}
              </MenuItem>
            )
          },
        )}
      </TextField>

      <Stack direction="row" spacing={1}>
        <RouterLink to={routes.account}>
          <IconButton color="primary">
            <PersonOutline />
          </IconButton>
        </RouterLink>
        <IconButton
          color="primary"
          title="Ajuda"
          component="a"
          href={`https://api.whatsapp.com/send?phone=${OCTA_DESK_PHONE}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <QuestionMark />
        </IconButton>
      </Stack>
    </Stack>
  )
}
